import EventEmitter from "./Events.utils";

class SnackbarUtils {
    success = (message) => {
        EventEmitter.dispatch(EventEmitter.SHOW_SNACKBAR, {
            error: message,
            type: 'success'
        });
    }

    error = (message) => {
        EventEmitter.dispatch(EventEmitter.SHOW_SNACKBAR, {
            error: message,
            type: 'error'
        });
    }

    infoMessage = (message, link) => {
        EventEmitter.dispatch(EventEmitter.SHOW_SNACKBAR, {
            error: message,
            type: 'info',
        });
    }
    
    info = (message, link) => {
        EventEmitter.dispatch(EventEmitter.SHOW_SNACKBAR, {
            error: message,
            type: 'info',
            link: window.location.origin+link
        });
    }
}

export default new SnackbarUtils();
